import {
  attachAsyncAppsFromManifest,
  initFederation,
  loadManifest,
} from '@gohighlevel/ghl-module-federation-plugin'
import * as Pinia from 'pinia'
import * as Vue from 'vue'

const remoteConfigEnv = {
  development: {
    calendarSettingsApp: 'https://staging.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    qrCodeBuilderApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true',
    calendarMeetingsApp: 'https://staging.appcdn.leadconnectorhq.com/automation/calendar-meetings/remoteEntry.js?nocache=true',
  },
  staging: {
    calendarSettingsApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    qrCodeBuilderApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true',
    calendarMeetingsApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-meetings/remoteEntry.js?nocache=true',
  },
  interop: {
    calendarSettingsApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    qrCodeBuilderApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true',
    calendarMeetingsApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/calendar-meetings/remoteEntry.js?nocache=true',
  },
  beta: {
    calendarSettingsApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    qrCodeBuilderApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true',
    calendarMeetingsApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/calendar-meetings/remoteEntry.js?nocache=true',
  },
  production: {
    calendarSettingsApp:
      'https://appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    qrCodeBuilderApp: 'https://appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true',
    calendarMeetingsApp:
      'https://appcdn.leadconnectorhq.com/automation/calendar-meetings/remoteEntry.js?nocache=true',
  },
}

let config = remoteConfigEnv[process.env.NODE_ENV]

export const initRemoteApps = async () => {
  const env = process.env.NODE_ENV

  const buildRemotes = config =>
    Object.entries(config).map(([key, entry]) => ({
      name: key,
      alias: key,
      entry,
    }))

  const initWithRemotes = config => {
    const remoteApps = buildRemotes(config)
    initFederation({
      name: 'settings-remote-apps',
      remotes: remoteApps,
      shared: {
        vue: {
          version: Vue.version,
          lib: () => Vue,
          shareConfig: { singleton: true, requiredVersion: '^3.2.45' },
        },
        pinia: {
          version: '2.1.7',
          lib: () => Pinia,
          shareConfig: { singleton: true, requiredVersion: '^2.0.0' },
        },
      },
    })
  }

  if (env !== 'development' && env !== 'staging') {
    await loadManifest(env)
    config = attachAsyncAppsFromManifest(config, env)
    initWithRemotes(config)
    return
  }
  initWithRemotes(config)
}
